import React from 'react';
import { Product } from '@/types';
import { motion } from 'framer-motion';
import { fadeInBottom } from '@/lib/framer-motion/fade-in-bottom';
import ProductReviewWidget from '@/components/product/product-review-widget';
import ProductSocialShare from '@/components/product/product-social-share';
import Grid from '@/components/product/grid';
import { cn } from '@/lib/utils';

interface SimilarProductsProps {
  product: Product;
  similarProducts: Product[];
  loadMore: () => void;
  hasNextPage?: boolean;
  isLoadingMore: boolean;
  isLoadingSimilarProducts: boolean;
  limitSimilarProducts: number;
}

export const SimilarProducts: React.FC<SimilarProductsProps> = ({
  product,
  similarProducts,
  loadMore,
  hasNextPage,
  isLoadingMore,
  isLoadingSimilarProducts,
  limitSimilarProducts,
}) => {
  return (
    <motion.div
      variants={fadeInBottom()}
      className="justify-center py-6 lg:flex lg:flex-col lg:py-10"
    >
      <div
        className={cn(
          'mt-4 w-full md:mt-8 md:space-y-10 lg:mt-12 lg:hidden lg:flex-col lg:space-y-12',
          product.is_custom_ai_model && 'hidden'
        )}
      >
        <ProductReviewWidget product={product} />
      </div>
      <ProductSocialShare
        productSlug={product.slug}
        className="hidden border-t border-light-500 pt-5 dark:border-dark-400 md:pt-7"
      />
      <h2 className="w-full border-b border-light-500 pb-2 pt-5 text-lg tracking-tight text-dark dark:border-dark-400 dark:text-light">
        You may also like
      </h2>
      <div className="search-results -mx-4 flex min-h-[84%] flex-col px-4 md:-mx-6 lg:-mx-7 lg:py-2 xl:px-20 3xl:-mx-8">
        <Grid
          products={similarProducts}
          onLoadMore={loadMore}
          hasNextPage={hasNextPage}
          isLoadingMore={isLoadingMore}
          isLoading={isLoadingSimilarProducts}
          limit={limitSimilarProducts}
          disableAutoLoad
        />
      </div>
    </motion.div>
  );
};
